import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";
import { ItemDisplayRecord } from "../shared/ItemDisplayRecord";

export const ItemCardDisplayRecord = Record({
  itemDisplay: ItemDisplayRecord(),
  rect: FlatRectRecord(),
  indentationLevel: 0,
  hasChildren: false,
  childrenExpanded: false
});

const data = {
  objects: {
    // titleMetrics: "TextMetricsRecord",
    itemDisplay: "ItemDisplayRecord",
    rect: "FlatRectRecord"
  }
};
createFromJS.registerCallback("ItemCardDisplayRecord", createFromJS.createNestedCallback(ItemCardDisplayRecord, data));
